import { apiCall } from '../actions/api-call';
import DocumentService from '../../ports/DocumentService';
import { SaveDocumentRequestAction, saveDocument, uploadDocument, UploadDocumentRequestAction } from '../actions/document';
import { FileSaverService } from '../../ports/FileSaver';
import { Novel } from '../middlewares/novels';
import { Action } from '../actions';

function parseBlobError(blob: Blob): any {
  const fileReader = new FileReader();

  return new Promise((resolve, reject) => {
    fileReader.onerror = () => {
      fileReader.abort();
      reject(new Error('Problem parsing error response'));
    };

    fileReader.onload = () => {
      let details = fileReader.result as string;
      try {
        details = JSON.parse(details);
      } catch (err) {
        resolve(details);
      }
      resolve(details);
    };

    fileReader.readAsText(blob);
  });
}

export interface DocumentNovels {
  saveDocumentNovel: Novel<SaveDocumentRequestAction, Action>;
  uploadDocumentNovel: Novel<UploadDocumentRequestAction, Action>;
}

export const documentNovelsCreator = (
  documentService: DocumentService,
  fileSaverService: FileSaverService,
): DocumentNovels => {
  const saveDocumentNovel = async (
    { data }: SaveDocumentRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      const result = await documentService.saveDocument(data);

      fileSaverService(result, data.fileName);

      dispatch(apiCall.success());
      dispatch(saveDocument.success());
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      if (err.response && err.response.data) {
        const details = await parseBlobError(err.response.data);
        return dispatch(saveDocument.failure(details));
      }
      dispatch(saveDocument.failure(err.message));
    }
  };

  const uploadDocumentNovel = async (
    { data }: UploadDocumentRequestAction,
    dispatch: (action: Action) => void,
  ) => {
    try {
      dispatch(apiCall());
      await documentService.uploadDocument(data.document);

      dispatch(apiCall.success());
      dispatch(uploadDocument.success(data.truck, data.document));
    } catch (err) {
      dispatch(apiCall.failure(err.message));
      dispatch(uploadDocument.failure(err.message, data.truck, data.document));
    }
  };

  return {
    saveDocumentNovel,
    uploadDocumentNovel,
  };
};
